module.exports = __webpack_public_path__ + "img/3.7cbc81b2.jpg";